import './ActionConfirmationModal.scss';
import { FC } from 'react';
import { ModalSize } from '@srm/ui/types/ModalSize';
import MessageDialog from '@srm/ui/message-dialog';

export interface IActionConfirmationModalProps {
    title: string;
    message: string;
    size?: ModalSize;
    okButtonText?: string;
    cancelButtonText?: string;
    onOkClick: () => Promise<void>;
    onCancelClick: () => void;
}

const ActionConfirmationModal: FC<IActionConfirmationModalProps> = ({
    title,
    message,
    size = 'm',
    okButtonText = 'ОК',
    cancelButtonText = 'Отмена',
    onOkClick,
    onCancelClick,
}: IActionConfirmationModalProps) => {
    return (
        <MessageDialog
            header={title}
            size={size}
            showOkButton={true}
            showCancelButton={true}
            okButtonText={okButtonText}
            cancelButtonText={cancelButtonText}
            message={message}
            onConfirm={onOkClick}
            onCancel={onCancelClick}
        />
    );
};

export default ActionConfirmationModal;
